// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");

function ToggleInput(props) {
  var __labelClassName = props.labelClassName;
  var __disabled = props.disabled;
  var disabled = __disabled !== undefined ? __disabled : false;
  var labelClassName = __labelClassName !== undefined ? __labelClassName : "flex items-center";
  var className = "switch " + labelClassName + " ";
  return JsxRuntime.jsxs("label", {
              children: [
                JsxRuntime.jsx("input", {
                      checked: props.checked,
                      disabled: disabled,
                      type: "checkbox",
                      onChange: props.handleChange
                    }),
                JsxRuntime.jsx("span", {
                      className: "slider round"
                    })
              ],
              className: className + (
                disabled ? "disabled-input cursor-not-allowed" : "cursor-pointer"
              )
            });
}

var make = ToggleInput;

exports.make = make;
/* react/jsx-runtime Not a pure module */
